<div class="admin-chats">
  <h1 class="mb-6 text-2xl font-semibold text-gray-900">National chat</h1>

  <section class="mb-8 rounded-lg border border-gray-200 bg-white p-4">
    <h2 class="mb-3 text-lg font-medium text-gray-900">Send announcement</h2>
    <form [formGroup]="announceForm" (ngSubmit)="sendAnnouncement()" class="flex flex-col gap-3">
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Title (optional)</mat-label>
        <input matInput formControlName="title" placeholder="Announcement title" />
      </mat-form-field>
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Message</mat-label>
        <textarea matInput formControlName="message" rows="3" placeholder="Announcement text"></textarea>
        <mat-error *ngIf="announceForm.get('message')?.hasError('required')">Message is required</mat-error>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="announceForm.invalid || announceSending"
      >
        {{ announceSending ? 'Sending…' : 'Send announcement' }}
      </button>
    </form>
  </section>

  <section class="rounded-lg border border-gray-200 bg-white p-4">
    <h2 class="mb-3 text-lg font-medium text-gray-900">Delete national chat message</h2>
    <p class="mb-3 text-sm text-gray-700">
      Enter the message ID to delete it from the national chat (e.g. from support or logs).
    </p>
    <div class="flex flex-wrap items-center gap-2">
      <mat-form-field appearance="outline" class="min-w-[120px]">
        <mat-label>Message ID</mat-label>
        <input matInput [formControl]="deleteMessageId" placeholder="e.g. 12345" type="text" />
        <mat-error *ngIf="deleteMessageId.hasError('required')">ID is required</mat-error>
      </mat-form-field>
      <button
        mat-raised-button
        color="warn"
        (click)="deleteMessage()"
        [disabled]="deleteMessageId.invalid || deleting"
      >
        {{ deleting ? 'Deleting…' : 'Delete message' }}
      </button>
    </div>
  </section>
</div>
